// extracted by mini-css-extract-plugin
module.exports = {"betSlip":"_8136653","content":"_628df00","emptyBetSlip":"_87254ca"};